<template>
  <div class="Leaflet">

    <v-card-text
      v-if="loading"
      class="text-xs-center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-card-text>

    <div v-else>

        <v-layout align-center justify-center row fill-height>
            <v-flex xs8>
                <div style="height: 90vh; width: 100%" >
                    <l-map
                        :zoom="zoom"
                        maxNativeZoom=18
                        :center="center"
                        :options="mapOptions"
                        style="height: 100%"
                        @update:center="centerUpdate"
                        @update:zoom="zoomUpdate"
                    >
                        <l-tile-layer
                        :url="url"
                        :attribution="attribution"
                        :options="tileOptions"
                        />

                        <l-control :position="'bottomleft'" class="example-custom-control">
                        <v-container>
                            <v-layout align-space-between justify-start column>
                            <v-card width="200" >

                                <v-card-title primary-title>
                                <h4>Mapa Depto Municipio</h4>
                                </v-card-title>

                                <v-card-text>
                                <v-layout align-space-between justify-start column fill-height>
                                    <v-flex v-for="n in 7" :key="n">
                                    <span class="font-weight-black  ">{{colores[n-1][1]}}</span>
                                    <v-icon small  :color="colores[n-1][0]">lens</v-icon>
                                    <span class="">{{colores[n-1][2]}}</span>
                                    </v-flex>
                                </v-layout>
                                <br>

                                <v-autocomplete
                                    v-model="modelDpto"
                                    :items="lista_dptos"
                                    box
                                    item-value="value"
                                    item-text="key"
                                    label="Localidad"
                                >
                                </v-autocomplete>
                                </v-card-text>

                                <div class="text-xs-center">
                                <v-btn round color="primary" dark  @click="buscarMunicipios(modelDpto)">Buscar Municipios</v-btn>
                                </div>

                            </v-card>

                            </v-layout>
                        </v-container>
                        </l-control>

                        <l-control-scale position="topright" :imperial="false" :metric="true"></l-control-scale>

                        <template v-if="maps_departamentos">
                        <l-geo-json :geojson="geojsonDpto"  :options="optionsGeoDpto"></l-geo-json>
                        </template>

                        <template v-if="maps_municipios">

                        <l-geo-json :geojson="geojsonMuni"  :options="optionGeoMuni"></l-geo-json>

                        </template>

                    </l-map>
                </div>

            </v-flex>
             <v-flex xs4>
                <h2>hey</h2>
            </v-flex>

        </v-layout>

    </div>

  </div>
</template>

<script>

// import JsonPretty from 'vue-json-pretty'
// import moment from 'moment'
import { latLng } from 'leaflet'
import 'leaflet/dist/leaflet.css'

import { LMap, LTileLayer, LControl, LControlScale, LGeoJson } from 'vue2-leaflet'
// import { LMap, LTileLayer, LLayerGroup, LControlScale, LMarker, LPopup, LTooltip, LGeoJson } from 'vue2-leaflet'

export default {
  name: 'Mapa General',
  components: {
    LMap,
    LTileLayer,
    // LLayerGroup,
    LControlScale,
    // LPopup,
    LControl,
    LGeoJson
    // LPolygon
  },
  data: function () {
    return {
      path: './images/icono.png',
      backConf: {
        path: '/briefcase/localizacion',
        pathFiltro: '/charts/resumen_enc',
        pathHome: '/maps/localidad/?page=',
        pathMapa: '/projects/covid/mapa/',
        pathLocalidades: '/maps/localidad/',
        pathRiesgos: '/projects/covid/municipios/',
        pathPersona: '/projects/covid/persona/',
        page: 1,
        pathDepartamentos: '/maps/departamento/',
        pathMunicipios: '/maps/municipio/'
      },

      loading: false,
      progressSize: 70,
      progressWidth: 7,
      progressTotal: 0,
      progressAdvance: 0,
      completed: 0,

      operativo: null,

      panel: [false],

      dateIni: null,
      dateEnd: null,
      filter: [],

      filterBy: null,
      alert: false,

      markers: [],

      zoom: 7,
      center: latLng(4.60971, -74.08175),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(4.60871, -74.11379),
      withTooltip: latLng(4.60971, -74.08175),
      currentZoom: 7,
      currentCenter: latLng(4.60971, -74.08175),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        maxZoom: 23
      },
      tileOptions: {
        maxZoom: 23,
        maxNativeZoom: 19
      },

      clustering: true,
      clusterOptions: {},

      localidades: null,

      popupName: null,

      optionGeoMuni: {
        style: function (feature) {
          if (feature.properties.divipola) {
            return {
              weight: 3,
              color: feature.properties.color
            }
          } else {
            return {
              weight: 3,
              color: '#000000'
            }
          }
        },
        onEachFeature: function onEachFeature (feature, layer) {
          if (feature.properties.divipola) {
            layer.bindPopup(
              feature.properties.nombre + '<br/>' +
              'Divipola:  ' + feature.properties.divipola + '<br/>' +
              'Riesgo:  ' + feature.properties.riesgo + ' %'
            )
          } else {
            layer.bindPopup('Not in port')
          }
        }
      },

      optionsGeoDpto: {
        style: function (feature) {
          return {
            weight: 3,
            color: feature.properties.color
          }
        },
        onEachFeature: function onEachFeature (feature, layer) {
          if (feature.properties.divipola) {
            layer.bindPopup(
              feature.properties.nombre + '<br/>' +
              'Código:  ' + feature.properties.divipola
            )
          } else {
            layer.bindPopup('Not in port')
          }
        }
      },

      caller: null,
      selectedLoc: [],
      maps_departamentos: false,
      poligonos: [],
      aux: null,
      taux: [],
      tabla_riesgos: [],
      tabla_colores: [],
      l_prob: null, // probabilidad de cada localidad
      l_nombre: null,
      l_num: null,
      p_nombre: null,
      p_cedula: null,
      l_divipola: null,
      token: null,

      iconSize: 64,

      max: null,
      color7: '#000000',
      color6: 'red',
      color5: '#D50000',
      color4: '#E65100',
      color3: '#FFAB00',
      color2: '#FFEB3B',
      color1: '#64DD17',
      colores: [
        ['black', 'Muy Alto', '60% - 100%'],
        ['#D50000', 'Alto', '30% - 60%'],
        ['#B71C1C', 'Medio 3', '21% - 30%'],
        ['#E65100', 'Medio 2', '16& - 20%'],
        ['#FFAB00', 'Medio 1', '11% - 15%'],
        ['#FFEB3B', 'Bajo', '6% - 10%'],
        ['#64DD17', 'Muy Bajo', '0% - 5%']
      ],
      modelDpto: null,
      modelDpto2: null,
      departamentos: [],
      lista_dptos: [],

      maps_municipios: false,
      municipios: [],
      geojsonMuni: null,
      geojsonMuniPrueba: null,
      geomuni: [],
      geomuni2: [],

      geojsonDpto: null,
      geojsonDptoPrueba: null,
      geodpto: [],

      offset: 0
    }
  },

  watch: {
    '$store.state.actualProject': function () {
      this.operativo = this.$store.state.actualProject.id
    }
  },
  /**
     * Esta función carga el respectivo Layout, al crear la vista.
     */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    this.getPoligonosDepartamentos()
  },

  methods: {

    /**
    * Genera la tabla_riesgos de Municipios
    * Genera la tabla_colores
    * y Obtiene el numero Max que es la diferencia entre
    * el mayor dividido 5
    */
    getRiesgosMunicipios (dpto) {
      console.log('GET RIESGOS')

      this.loading = false
      let request = {
        method: 'get',
        url: this.backConf.pathRiesgos,
        params: {
          divipola: dpto
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          let aux = resp.data.results
          for (const mun in aux) {
            let id = aux[mun].divipola
            let r = aux[mun].riesgo
            if (r < 5) {
              t.tabla_riesgos[id] = { color: t.color1, riesgo: r }
            } else if (r < 10) {
              t.tabla_riesgos[id] = { color: t.color2, riesgo: r }
            } else if (r < 15) {
              t.tabla_riesgos[id] = { color: t.color3, riesgo: r }
            } else if (r < 20) {
              t.tabla_riesgos[id] = { color: t.color4, riesgo: r }
            } else if (r < 30) {
              t.tabla_riesgos[id] = { color: t.color5, riesgo: r }
            } else if (r < 60) {
              t.tabla_riesgos[id] = { color: t.color6, riesgo: r }
            } else {
              t.tabla_riesgos[id] = { color: t.color7, riesgo: r }
            }
          }

          console.log('TAABLA')
          console.log(t.tabla_riesgos)
        })
        .catch(function (err) {
          console.error(err)
        })
    },

    /**
    * Recibe las coordenadas (poligonos) y mas propiedades de los departamentos
    * y las asigna a un arreglo agregandole su respectivo color segun
    * porcentaje riesgo
    */
    getPoligonosDepartamentos (dpto) {
      this.loading = true
      let request = {
        method: 'get',
        url: this.backConf.pathDepartamentos,
        params: {
          operativo: this.operativo,
          offset: this.offset
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.geojsonDptoPrueba = resp.data.results
          let features = resp.data.results.features

          for (const ff in features) {
            features[ff].properties['color'] = 'blue'
            let dpto = {
              key: features[ff].properties.nombre,
              value: features[ff].properties.divipola
            }
            t.lista_dptos.push(dpto)
          }
          t.geodpto = t.geodpto.concat(features)

          if (resp.data.next !== null) {
            t.offset += 10
            t.getPoligonosDepartamentos()
          } else {
            t.offset = 0
            t.loading = false
            t.maps_departamentos = true
            t.geojsonDpto = t.geojsonDptoPrueba
            t.geojsonDpto.features = t.geodpto
          }
        })
        .catch(function (err) {
          console.error(err)
        })
    },

    /**
    * Recibe las coordenadas (poligonos) y mas propiedades de los municipios
    * y las asigna a un arreglo agregandole su respectivo color segun
    * porcentaje riesgo
    */
    getPoligonosMunicipios (dpto) {
      // this.loading = true
      let request = {
        method: 'get',
        url: this.backConf.pathMunicipios,
        params: {
          offset: this.offset,
          departamento: dpto
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.geojsonMuniPrueba = resp.data.results
          let features = resp.data.results.features
          console.log('features')
          for (const ff in features) {
            let divipola = features[ff].properties.divipola
            let color = t.tabla_riesgos[divipola].color
            let riesgo = t.tabla_riesgos[divipola].riesgo
            features[ff].properties['color'] = color
            features[ff].properties['riesgo'] = riesgo
          }
          t.geomuni = t.geomuni.concat(features)

          if (resp.data.next !== null) {
            t.offset += 10
            t.getPoligonosMunicipios(dpto)
          } else {
            t.offset = 0
            t.loading = false
            t.maps_departamentos = true
            t.maps_municipios = true
            t.geojsonMuni = t.geojsonMuniPrueba
            t.geojsonMuni.features = t.geomuni
          }
        })
        .catch(function (err) {
          console.error(err)
        })
    },
    // Leaflet
    zoomUpdate (zoom) {
      this.currentZoom = zoom
    },
    centerUpdate (center) {
      this.currentCenter = center
    },
    showLongText () {
      this.showParagraph = !this.showParagraph
    },

    LatLongPoint (lat, long) {
      return latLng(lat, long)
    },

    // async loadGeo () {
    //   const response = await fetch('https://rawgit.com/gregoiredavid/france-geojson/master/regions/pays-de-la-loire/communes-pays-de-la-loire.geojson')
    //   this.geojson = await response.json()
    // },
    /**
    * Funcion para poner en pop up propiedades
    * del marcador
    */
    openPopUp (latLng, caller) {
      this.p_cedula = null
      this.p_nombre = null
      console.log('token: ' + caller)
      this.token = caller
      this.getPersona()
      this.$refs.features.mapObject.openPopup(latLng)
    },

    /**
    * Funcion para poner en pop up propiedades
    * de la localidad
    */
    openPopUp2 (latLng, nombre, riesgo, divipola) {
      this.l_nombre = nombre
      this.l_num = riesgo
      this.l_divipola = divipola
      let text = riesgo
      this.l_prob = String(text) + ' %'
      this.$refs.features.mapObject.openPopup(latLng)
    },

    buscarMunicipios (dpto) {
      console.log(dpto)
      this.getPoligonosMunicipios(dpto)
      this.getRiesgosMunicipios(dpto)
    }

  }

}
</script>

<style scoped>
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
  /* .Leaflet {
    text-align:left;
    height:85%;
    width:100%;
    position: absolute;
  } */

  .example-custom-control {
    position: sticky;
    z-index: 9999;
  }
   /* .l-map {
    overflow:hidden;
    background:none!important;
    height:100%;
    width:100%;
  } */
  /* .totalMarks {
    position: absolute;
    top: 3px;
    left: 29px;
  } */
</style>
